import type { PhotoLineController } from '../photo-editor/usePhotoLine';
import { DockedBar } from './DockedBar';
import { LineActions, type LineActionsLabels } from './LineActions';

interface LinePopoverProps {
  editor: PhotoLineController;
  labels: LineActionsLabels;
  /** Offer the corridor. Off on rock, where the line is the whole topo. */
  allowCorridor?: boolean;
}

/**
 * What can be done to the point in hand, along the bottom of the picture.
 *
 * Not at the point. A line is drawn from the ground up and every point of it is
 * on the way to the next one, so a panel standing at the last point would cover
 * exactly the wall the setter is about to press — and it would move with every
 * press, which is a control that will not hold still under a thumb. What it sets
 * is the *line*, not that point: two widths and a bin, none of which is about
 * where on the wall the point happens to be.
 *
 * Only while a point is in hand, unlike the holds' bar (`PhotoHoldBar`): there
 * is nothing to arm before the first press, since a line has one colour and the
 * next point is always the next point.
 */
export function LinePopover({ editor, labels, allowCorridor = true }: LinePopoverProps) {
  const { points, selected, thickness, corridor, setThickness, setCorridor, deleteSelected } =
    editor;

  if (selected === null || !points[selected]) return null;

  return (
    <DockedBar>
      <LineActions
        testId="line-command-bar"
        thickness={thickness}
        corridor={corridor}
        onThickness={setThickness}
        onCorridor={setCorridor}
        onDelete={deleteSelected}
        allowCorridor={allowCorridor}
        labels={labels}
      />
    </DockedBar>
  );
}
